module.exports = __webpack_public_path__ + "img/Droid-Botton.b683e911.png";